import { render, staticRenderFns } from "./BenefitsModal.vue?vue&type=template&id=7b931fe8&scoped=true&"
import script from "./BenefitsModal.vue?vue&type=script&lang=js&"
export * from "./BenefitsModal.vue?vue&type=script&lang=js&"
import style0 from "./BenefitsModal.vue?vue&type=style&index=0&id=7b931fe8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b931fe8",
  null
  
)

export default component.exports